/** Cache key of a flow's calculator quote — shared by the hook and the watcher. */
const projectCreditsQueryKey = (flowId: string | undefined | null) =>
  ['project-credits', flowId] as const;

export default projectCreditsQueryKey;
